
import React from 'react';
import { Instagram, MessageSquare, TwitchIcon, Twitter, Youtube } from 'lucide-react';

export const getPlatformIcon = (platform: string) => {
  switch (platform) {
    case 'instagram':
      return <Instagram className="h-3.5 w-3.5" />;
    case 'tiktok':
      return <TwitchIcon className="h-3.5 w-3.5" />;
    case 'twitter':
      return <Twitter className="h-3.5 w-3.5" />;
    case 'youtube':
      return <Youtube className="h-3.5 w-3.5" />;
    default:
      return <MessageSquare className="h-3.5 w-3.5" />;
  }
};
